import clsx from 'clsx';
import { useOffertePanelStore } from '../../stores/offerte-panel-store';

export function OfferteCapacityBumpCard() {
  const isOpen = useOffertePanelStore((s) => s.capacityBumpOpen);
  const routeId = useOffertePanelStore((s) => s.capacityBumpRouteId);
  const delta = useOffertePanelStore((s) => s.capacityBumpDelta);
  const reason = useOffertePanelStore((s) => s.capacityBumpReason);
  const isSubmitting = useOffertePanelStore((s) => s.capacityBumpSubmitting);
  const error = useOffertePanelStore((s) => s.capacityBumpError);
  const setDelta = useOffertePanelStore((s) => s.setCapacityBumpDelta);
  const setReason = useOffertePanelStore((s) => s.setCapacityBumpReason);
  const submit = useOffertePanelStore((s) => s.submitCapacityBump);
  const close = useOffertePanelStore((s) => s.closeCapacityBump);
  const routes = useOffertePanelStore((s) => s.routes);

  if (!isOpen || !routeId) return null;

  const route = routes.find((r) => r.routeId === routeId);
  const canSubmit = !isSubmitting && reason.trim().length >= 3 && delta >= 1 && delta <= 10;

  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-4 space-y-3">
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-sm font-semibold text-amber-900">Capaciteit verhogen</h3>
          <p className="text-xs text-amber-800 mt-0.5">
            {route
              ? `${route.dagNaam ?? route.datum} ${route.tijdslot} — nu ${route.capaciteit} plek${route.capaciteit === 1 ? '' : 'ken'} vrij`
              : 'Route geselecteerd voor capaciteit-uitbreiding'}
          </p>
        </div>
        <button
          type="button"
          onClick={close}
          className="text-xs text-amber-800 hover:underline"
        >
          Annuleren
        </button>
      </div>

      <div className="space-y-2">
        <label className="text-xs font-medium text-amber-900 block">Aantal plekken erbij</label>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setDelta(Math.max(1, delta - 1))}
            disabled={delta <= 1}
            className="w-8 h-8 rounded-md border border-amber-300 bg-white text-amber-900 disabled:opacity-40"
          >
            −
          </button>
          <span className="text-sm font-medium text-amber-900 w-8 text-center">{delta}</span>
          <button
            type="button"
            onClick={() => setDelta(Math.min(10, delta + 1))}
            disabled={delta >= 10}
            className="w-8 h-8 rounded-md border border-amber-300 bg-white text-amber-900 disabled:opacity-40"
          >
            +
          </button>
          <span className="text-xs text-amber-700 ml-2">max +10</span>
        </div>
      </div>

      <div className="space-y-2">
        <label className="text-xs font-medium text-amber-900 block">
          Reden <span className="text-amber-700">(verplicht, min. 3 tekens)</span>
        </label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Bijv. spoedklant, offerte-acceptatie krappe week..."
          rows={2}
          className="w-full px-3 py-2 text-sm border border-amber-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-amber-500 resize-none"
        />
      </div>

      <p className="text-[11px] text-amber-800">
        Dit wordt zichtbaar voor backoffice en gelogd op de lead met je e-mailadres.
      </p>

      {error && (
        <div className="px-3 py-2 bg-red-50 border border-red-200 rounded-md text-xs text-red-700">
          {error}
        </div>
      )}

      <button
        type="button"
        onClick={submit}
        disabled={!canSubmit}
        className={clsx(
          'w-full px-4 py-2.5 text-sm font-medium rounded-md transition-colors',
          canSubmit
            ? 'bg-amber-600 text-white hover:bg-amber-700'
            : 'bg-slate-200 text-slate-400 cursor-not-allowed'
        )}
      >
        {isSubmitting ? 'Bezig...' : `Capaciteit +${delta} toepassen`}
      </button>
    </div>
  );
}
